import React from 'react'
import { useAppDispatch, useAppSelector } from '../../state/hooks'
import ConfirmDialog, {
  ConfirmDialogState,
} from '../../components/ConfirmDialog'
import {
  selectDeleteCommentConfirmDialog,
  setDeleteCommentConfirmDialog,
} from '../../state/appSlice'
import { useMutation } from 'react-relay'
import { graphql } from 'relay-runtime'
import { toast } from 'react-toastify'
import { DeleteCommentConfirmDialogMutation } from './__generated__/DeleteCommentConfirmDialogMutation.graphql'

interface DeleteCommentConfirmDialogProps extends ConfirmDialogState {
  refreshData: () => void
}

const updateCampaignMutation = graphql`
  mutation DeleteCommentConfirmDialogMutation($input: DeleteRequest!) {
    deleteComment(input: $input) {
      id
    }
  }
`

const DeleteCommentConfirmDialog = ({
  refreshData,
  ...props
}: DeleteCommentConfirmDialogProps) => {
  const dispatch = useAppDispatch()
  const [request, loading] = useMutation<DeleteCommentConfirmDialogMutation>(
    updateCampaignMutation
  )

  const onCompleted = () => {
    refreshData()
    toast.success('Successfully deleted comment.')
  }
  const onError = (error: Error) => {
    console.log(error)
    toast.error('Unable to delete comment.')
  }
  const confirm = () => {
    request({
      variables: {
        input: {
          id: props.objectId!,
        },
      },
      onCompleted,
      onError,
    })
  }

  return (
    <>
      <ConfirmDialog
        {...props}
        confirm={confirm}
        close={() => dispatch(setDeleteCommentConfirmDialog({ open: false }))}
        disableActions={loading}
        body="Are you sure that you want to delete this comment? This action cannot be undone."
        confirmText="Delete"
        title="Delete Comment"
      />
    </>
  )
}

export default DeleteCommentConfirmDialog

interface DeleteCommentConfirmDialogContainerProps {
  refreshData: () => void
}

export const DeleteCommentConfirmDialogContainer = (
  props: DeleteCommentConfirmDialogContainerProps
) => {
  const data = useAppSelector(selectDeleteCommentConfirmDialog)
  if (!data.open) {
    return <></>
  }
  return <DeleteCommentConfirmDialog {...props} {...data} />
}
